import { Routes } from '@angular/router';
import { UserRole } from '@shared/types/user';
import { checkPermissionGuard } from '../guards/check-permission.guard';
import { loggedInAuthGuard } from '../guards/is-logged-in.guard';

export const QUIZ_ROUTES: Routes = [
  {
    path: 'quiz-theme',
    loadChildren: () =>
      import('./theme/theme.module').then((m) => m.QuizThemeModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin, UserRole.ClientAdmin],
    },
  },
  {
    path: 'matches',
    loadChildren: () =>
      import('./matches/matches.module').then((m) => m.MatchesModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
  {
    path: 'quiz-games',
    loadComponent: () =>
      import('./game/containers/game.component').then(
        (m) => m.QuizGameComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'leaderboard',
    loadChildren: () =>
      import('./leaderboard/leaderboard.module').then(
        (m) => m.LeaderboardModule,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
        UserRole.CustomerSupport,
      ],
    },
  },
  {
    path: 'competitors',
    loadComponent: () =>
      import('./competitor/containers/competitor.component').then(
        (m) => m.CompetitorComponent,
      ),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
  {
    path: 'questions',
    loadChildren: () =>
      import('./questions/questions.module').then((m) => m.QuestionsModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
  {
    path: 'answers',
    loadChildren: () =>
      import('./answers/answers.module').then((m) => m.QuestionsModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [UserRole.Admin],
    },
  },
  {
    path: 'quiz-prizes',
    loadChildren: () =>
      import('./prizes/prizes.module').then((m) => m.PrizesModule),
    canActivate: [loggedInAuthGuard, checkPermissionGuard],
    data: {
      permission: [
        UserRole.Admin,
        UserRole.ClientAdmin,
        UserRole.Manager,
        UserRole.Supervisor,
      ],
    },
  },
  // {
  //   path: 'submissions',
  //   loadChildren: () =>
  //     import('./submissions/submissions.module').then(
  //       (m) => m.SubmissionsModule,
  //     ),
  //   canActivate: [loggedInAuthGuard, checkPermissionGuard],
  //   data: {
  //     permission: [
  //       UserRole.Admin,
  //       UserRole.ClientAdmin,
  //       UserRole.Manager,
  //       UserRole.Supervisor,
  //       UserRole.CustomerSupport,
  //     ],
  //   },
  // },
];
